export default __webpack_public_path__ + "static/media/Integration_Filled.3a135c1f.svg";